var googleTagManagerService = {

    pushAddToCartDataLayer: function (
        price,
        articleNumber,
        productName,
        category,
        quantity,
        currency = 'SEK'
    ) {
        if (typeof dataLayer === 'undefined') {
            return false;
        }

        dataLayer.push({
            'event': 'add_to_cart',
            'currency': currency,
            'value': +price,
            'items': [
                {
                    'item_id': articleNumber,
                    'item_name': productName,
                    'item_category': category,
                    'price': +price,
                    'quantity': +quantity,
                }
            ]
        })
    }
}
